import { useCallback, useMemo } from 'react';

import { useUpdateDraftFilter } from 'src/components/Search/Common/Filters/hooks/draft/useUpdateDraftFilter';
import { useSelector } from 'src/hooks/useSelector';
import { CurrentGeoFilter } from 'src/models/search/common/geoDrawer';
import { ClusterKey } from 'src/types/search/common/clusters';

import { useGeoFiltersAnalytics } from 'src/components/Search/Resume/Filters/Geo/hooks/useAnalytics';

export const useResetButtonState = (): [boolean, () => void] => {
    const updateAreaDraftFilter = useUpdateDraftFilter(ClusterKey.Area);
    const updateMetroDraftFilter = useUpdateDraftFilter(ClusterKey.Metro);
    const updateDistrictDraftFilter = useUpdateDraftFilter(ClusterKey.District);
    const currentGeoFilter = useSelector((state) => state.searchGeoDrawer.currentGeoFilter);
    const allClusters = useSelector((state) => state.searchDraftClusters);

    const shouldShowButton = useMemo(
        () =>
            (currentGeoFilter === CurrentGeoFilter.AREA && !!allClusters?.[ClusterKey.Area]?.selectedValues?.length) ||
            (currentGeoFilter === CurrentGeoFilter.METRO &&
                !!allClusters?.[ClusterKey.Metro]?.selectedValues?.length) ||
            (currentGeoFilter === CurrentGeoFilter.DISTRICT &&
                !!allClusters?.[ClusterKey.District]?.selectedValues?.length),
        [currentGeoFilter, allClusters]
    );

    const { sendEventGeoDraftReset } = useGeoFiltersAnalytics();

    const handleReset = useCallback(() => {
        if (currentGeoFilter === CurrentGeoFilter.AREA) {
            updateAreaDraftFilter([]);
        }
        if (currentGeoFilter === CurrentGeoFilter.METRO) {
            updateMetroDraftFilter([]);
        }
        if (currentGeoFilter === CurrentGeoFilter.DISTRICT) {
            updateDistrictDraftFilter([]);
        }
        sendEventGeoDraftReset(currentGeoFilter);
    }, [
        currentGeoFilter,
        sendEventGeoDraftReset,
        updateAreaDraftFilter,
        updateMetroDraftFilter,
        updateDistrictDraftFilter,
    ]);

    return [shouldShowButton, handleReset];
};
